// Limit veľkosti dokumentov, ktoré idú na Cenzor engine (PDF, DOCX) — #162, 23. 9. 2026.
//
// Kontroluje sa už pri výbere súboru: príliš veľký súbor sa nepridá do zoznamu
// a nikam sa neposiela. Dovtedy klient poslal 162 MB súbor, nginx ho odmietol
// kódom 413 a v UI sa ukázalo len „Failed to start async job (status 413)“.
// Hodnota musí sedieť s CENZOR_UPLOAD_LIMIT_MB v backende.
export const MAX_UPLOAD_MB = Number(process.env.REACT_APP_MAX_UPLOAD_MB || 50);
export const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024;

export const formatMB = (bytes) =>
  (bytes / 1024 / 1024).toLocaleString('sk-SK', { maximumFractionDigits: 1 });

export const isTooBig = (file) => (file?.size || 0) > MAX_UPLOAD_BYTES;

export const splitBySize = (files) => ({
  ok: files.filter((f) => !isTooBig(f)),
  tooBig: files.filter(isTooBig),
});

export const tooBigMessage = (t, tooBig) =>
  tooBig.length === 1
    ? t('upload.tooBigOne', {
        defaultValue:
          'Súbor „{{name}}“ má {{size}} MB. Najväčší povolený súbor je {{limit}} MB. ' +
          'Rozdeľte ho na menšie časti alebo ho uložte v nižšom rozlíšení a nahrajte znova.',
        name: tooBig[0].name,
        size: formatMB(tooBig[0].size),
        limit: MAX_UPLOAD_MB,
        interpolation: { escapeValue: false },
      })
    : t('upload.tooBigMany', {
        defaultValue:
          'Tieto súbory sme nepridali, lebo sú väčšie ako {{limit}} MB: {{list}}. ' +
          'Rozdeľte ich na menšie časti a nahrajte znova.',
        limit: MAX_UPLOAD_MB,
        list: tooBig.map((f) => `${f.name} (${formatMB(f.size)} MB)`).join(', '),
        interpolation: { escapeValue: false },
      });

// Hlásenie cez notistack — dlhšie ako bežné upozornenie, klient si ho musí stihnúť prečítať.
export const notifyTooBig = (t, enqueueSnackbar, tooBig) => {
  if (!tooBig.length) return;
  enqueueSnackbar(tooBigMessage(t, tooBig), { variant: 'error', autoHideDuration: 15000 });
};

// Poistka priamo pred odoslaním (ak by sa súbor do zoznamu dostal inou cestou).
export const assertUploadSize = (file) => {
  if (isTooBig(file)) {
    throw new Error(
      `Súbor „${file.name}“ má ${formatMB(file.size)} MB. Najväčší povolený súbor je ` +
      `${MAX_UPLOAD_MB} MB. Rozdeľte ho na menšie časti a nahrajte znova.`
    );
  }
};
